import { render, staticRenderFns } from "./ColegioSelmTarde.vue?vue&type=template&id=0d1f64ff&scoped=true"
import script from "./ColegioSelmTarde.vue?vue&type=script&lang=js"
export * from "./ColegioSelmTarde.vue?vue&type=script&lang=js"
import style0 from "./ColegioSelmTarde.vue?vue&type=style&index=0&id=0d1f64ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1f64ff",
  null
  
)

export default component.exports